import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import {
  ButtonCustomWithDarkText,
  ButtonsWrapper,
  secondary,
} from "../../Style/Style";

interface IDeleteIconButtonProps {
  disabled?: boolean;
  deleteHandler(): void;
  item: string;
  fz?: number;
  withStopPropagation?: boolean;
}

export const DeleteIconButton = ({
  disabled,
  deleteHandler,
  item,
  fz,
  withStopPropagation,
}: IDeleteIconButtonProps) => {
  const [confirmModal, setConfirmModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  return (
    <>
      <IconButton
        disabled={disabled}
        onClick={(e) => {
          if (withStopPropagation) e.stopPropagation();
          setConfirmModal(true);
        }}
        style={{
          color: disabled ? secondary : "red",
          fontSize: fz ? `${fz}px` : "24px",
          padding: fz ? `${fz / 2}px` : "12px",
          lineHeight: 1,
        }}
      >
        <Delete color="inherit" fontSize="inherit" />
      </IconButton>

      <Dialog
        open={confirmModal}
        transitionDuration={500}
        onClick={(e) => {
          if (withStopPropagation) e.stopPropagation();
          setConfirmModal(false);
        }}
      >
        <DialogContent>
          <DialogTitle>Ви впевнені, що хочете видалити {item}?</DialogTitle>
          <ButtonsWrapper>
            <ButtonCustomWithDarkText
              active={false}
              onClick={(e) => {
                if (withStopPropagation) e.stopPropagation();
                setConfirmModal(false);
              }}
            >
              Відмінити
            </ButtonCustomWithDarkText>

            <ButtonCustomWithDarkText
              disabled={isProcessing}
              active={!isProcessing}
              onClick={async (e) => {
                if (isProcessing) return;
                setIsProcessing(true);
                if (withStopPropagation) e.stopPropagation();

                try {
                  await deleteHandler();
                } finally {
                  setConfirmModal(false);
                  setIsProcessing(false);
                }
              }}
            >
              Підтвердити
            </ButtonCustomWithDarkText>
          </ButtonsWrapper>
        </DialogContent>
      </Dialog>
    </>
  );
};
